module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gpicker"
  }, [(_vm.isInput) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "vinput",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }) : _c('div', {
    staticClass: "ginput",
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.disValue) ? [(_vm.isHtml) ? [_c('span', {
    staticClass: "bil",
    domProps: {
      "innerHTML": _vm._s(_vm.disValue)
    }
  })] : [_vm._v(_vm._s(_vm.disValue))]] : _c('span', {
    staticClass: "ph"
  }, [_vm._v(_vm._s(_vm.placeholder))])], 2), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-xia",
    on: {
      "click": _vm.open
    }
  }), _vm._v(" "), _c('vue-pickers', {
    attrs: {
      "show": _vm.show,
      "isHtml": _vm.isHtml,
      "selectData": _vm.optionSlot
    },
    on: {
      "cancel": _vm.close,
      "confirm": _vm.confirmFn
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-368a23f4","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/gpicker.vue
// module id = 1765
// module chunks = 107